/* Free Gift Popup logic for Dawn (O'RTE)
 * - ONE free ($0) gift per brand, options CUMULATIVE by qualifying-bottle count
 * - Gifts can have sizes (variants); popup shows a size picker for those
 * - Crossing thresholds keeps eligible gifts; removes only ineligible ones
 * - Removals use the cart line-item KEY (reliable), adds use the variant id
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('GiftPopupData');
  if (!dataEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[gift-popup] bad config JSON', e);
    return;
  }

  // Gifts must have at least one variant
  var GIFTS = (CONFIG.gifts || []).filter(function (g) {
    return Array.isArray(g.variants) && g.variants.length > 0;
  });
  if (!GIFTS.length) return;

  var GIFT_BY_VARIANT = {}; // variantId -> gift
  var GIFT_HANDLES = new Set();
  GIFTS.forEach(function (g) {
    GIFT_HANDLES.add(g.handle);
    g.variants.forEach(function (v) { GIFT_BY_VARIANT[v.id] = g; });
  });

  var BRANDS = Object.keys(CONFIG.qualifiers || {});
  var BRAND_LABEL = CONFIG.brandLabels || {};

  function qSet(brand, kind) {
    var q = CONFIG.qualifiers || {};
    return new Set(((q[brand] && q[brand][kind]) || []).filter(Boolean));
  }
  var QUAL = {};
  BRANDS.forEach(function (b) {
    QUAL[b] = { single: qSet(b, 'single'), double: qSet(b, 'double'), triple: qSet(b, 'triple') };
  });

  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';

  // ---- cart helpers -------------------------------------------------------
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
  }
  function addGift(variantId) {
    return postJSON(ADD_URL + '.js', { items: [{ id: variantId, quantity: 1 }] });
  }
  function changeQty(idOrKey, qty) {
    return postJSON(CHANGE_URL + '.js', { id: idOrKey, quantity: qty });
  }
  function runOps(ops) {
    return ops.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve());
  }
  function refreshCartUI() {
    return getCart().then(function (cart) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-popup', cartData: cart });
        }
      } catch (e) { /* noop */ }
      return fetch(CART_URL + '?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var el = document.getElementById('cart-icon-bubble');
          if (el) el.innerHTML = html;
        })
        .catch(function () {});
    });
  }

  // ---- rule evaluation ----------------------------------------------------
  function countBottles(cart) {
    var counts = {};
    BRANDS.forEach(function (b) { counts[b] = 0; });
    (cart.items || []).forEach(function (it) {
      var h = it.handle;
      var qty = it.quantity || 0;
      BRANDS.forEach(function (b) {
        if (QUAL[b].single.has(h)) counts[b] += qty;
        else if (QUAL[b].double.has(h)) counts[b] += qty * 2;
        else if (QUAL[b].triple.has(h)) counts[b] += qty * 3;
      });
    });
    return counts;
  }
  function giftOfItem(it) { return GIFT_BY_VARIANT[it.variant_id] || null; }
  function giftItemsInCart(cart) {
    return (cart.items || []).filter(function (it) {
      return GIFT_BY_VARIANT[it.variant_id] || GIFT_HANDLES.has(it.handle);
    });
  }
  function brandOfItem(it) {
    var g = giftOfItem(it);
    if (g) return g.brand;
    var found = GIFTS.filter(function (x) { return x.handle === it.handle; })[0];
    return found ? found.brand : null;
  }
  function eligibleForBrand(brand, count) {
    return GIFTS.filter(function (g) {
      return g.brand === brand &&
        count >= g.minBottles &&
        (g.maxBottles == null || count <= g.maxBottles);
    });
  }

  // ---- UI -----------------------------------------------------------------
  var popup = document.getElementById('GiftPopup');
  var grid = document.getElementById('GiftPopup-grid');
  var addBtn = document.getElementById('GiftPopup-add');
  var subtitle = popup ? popup.querySelector('.gift-popup__subtitle') : null;
  var trigger = document.getElementById('GiftTrigger');

  var currentGroups = [];        // [{brand, gifts:[...], current:{handle,variantId}|null}]
  var selection = {};            // { brand: {handle, variantId} }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function giftByHandle(brand, handle) {
    return GIFTS.filter(function (g) { return g.brand === brand && g.handle === handle; })[0] || null;
  }

  function updateAddState() {
    if (!addBtn) return;
    var ready = currentGroups.length > 0 && currentGroups.every(function (g) {
      return selection[g.brand] && selection[g.brand].variantId;
    });
    addBtn.disabled = !ready;
  }

  function renderGroups(groups) {
    currentGroups = groups;
    selection = {};
    groups.forEach(function (g) {
      if (g.current) selection[g.brand] = { handle: g.current.handle, variantId: g.current.variantId };
    });

    if (!grid) return;

    grid.innerHTML = groups.map(function (g) {
      var cards = g.gifts.map(function (gift) {
        var isSel = g.current && g.current.handle === gift.handle;
        var media = gift.image
          ? '<img src="' + gift.image + '" alt="" loading="lazy">'
          : '<span class="gift-card__noimg">&#127873;</span>';
        var sizePicker = '';
        if (gift.variants.length > 1) {
          var opts = gift.variants.map(function (v) {
            var selAttr = (isSel && g.current.variantId === v.id) ? ' selected' : '';
            return '<option value="' + v.id + '"' + selAttr + '>' + escapeHtml(v.title) + '</option>';
          }).join('');
          sizePicker = '<select class="gift-card__size" data-brand="' + g.brand + '" data-handle="' +
            escapeHtml(gift.handle) + '" aria-label="Size">' + opts + '</select>';
        }
        return (
          '<label class="gift-card' + (isSel ? ' is-selected' : '') + '">' +
          '<input type="radio" name="giftChoice-' + g.brand + '" value="' + escapeHtml(gift.handle) + '"' + (isSel ? ' checked' : '') + '>' +
          '<span class="gift-card__media">' + media + '</span>' +
          '<span class="gift-card__title">' + escapeHtml(gift.title) + '</span>' +
          sizePicker +
          '</label>'
        );
      }).join('');
      var heading = groups.length > 1
        ? '<h3 class="gift-popup__group-title">Your ' + escapeHtml(BRAND_LABEL[g.brand] || g.brand) + ' gift</h3>'
        : '';
      return '<div class="gift-popup__group" data-brand="' + g.brand + '">' + heading +
        '<div class="gift-popup__cards">' + cards + '</div></div>';
    }).join('');

    // radios: choose a gift
    Array.prototype.forEach.call(grid.querySelectorAll('input[type="radio"]'), function (inp) {
      inp.addEventListener('change', function () {
        var brand = inp.name.replace('giftChoice-', '');
        var gift = giftByHandle(brand, inp.value);
        if (!gift) return;
        var variantId = gift.variants[0].id;
        var card = inp.closest('.gift-card');
        if (gift.variants.length > 1 && card) {
          var sel = card.querySelector('.gift-card__size');
          if (sel) variantId = Number(sel.value);
        }
        selection[brand] = { handle: gift.handle, variantId: variantId };
        var groupEl = inp.closest('.gift-popup__group');
        if (groupEl) {
          Array.prototype.forEach.call(groupEl.querySelectorAll('.gift-card'), function (c) {
            c.classList.remove('is-selected');
          });
          if (card) card.classList.add('is-selected');
        }
        updateAddState();
      });
    });

    // size selects: update chosen variant (and select that gift)
    Array.prototype.forEach.call(grid.querySelectorAll('.gift-card__size'), function (sel) {
      sel.addEventListener('change', function () {
        var brand = sel.getAttribute('data-brand');
        var handle = sel.getAttribute('data-handle');
        var radio = grid.querySelector('input[name="giftChoice-' + brand + '"][value="' + handle + '"]');
        if (radio && !radio.checked) radio.checked = true;
        selection[brand] = { handle: handle, variantId: Number(sel.value) };
        var card = sel.closest('.gift-card');
        var groupEl = sel.closest('.gift-popup__group');
        if (groupEl && card) {
          Array.prototype.forEach.call(groupEl.querySelectorAll('.gift-card'), function (c) {
            c.classList.remove('is-selected');
          });
          card.classList.add('is-selected');
        }
        updateAddState();
      });
    });

    if (subtitle) {
      var anyMissing = groups.some(function (g) { return !g.current; });
      subtitle.textContent = anyMissing
        ? 'You’ve unlocked a gift with purchase. Make your choice below:'
        : 'Update your gift selection below:';
    }
    updateAddState();
  }

  function openPopup() { if (popup) { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); document.body.classList.add('gift-popup-open'); } }
  function closePopup() { if (popup) { popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); document.body.classList.remove('gift-popup-open'); } }

  function showTrigger(changeMode) {
    if (!trigger) return;
    var label = trigger.querySelector('.gift-trigger__label');
    if (label) label.textContent = changeMode ? 'Change your gift' : 'Choose your gift';
    trigger.hidden = false;
  }
  function hideTrigger() { if (trigger) trigger.hidden = true; }

  // ---- main loop ----------------------------------------------------------
  var processing = false;
  var pendingAuto = false;
  var evalTimer = null;
  var lastEligCount = {};    // brand -> eligible gift count at previous eval
  var evaluatedOnce = false; // don't treat the first (page-load) eval as an "unlock"

  function scheduleEvaluate(auto) {
    pendingAuto = pendingAuto || auto;
    clearTimeout(evalTimer);
    evalTimer = setTimeout(function () {
      var a = pendingAuto;
      pendingAuto = false;
      evaluate(a);
    }, 250);
  }

  function evaluate(autoOpen) {
    if (processing) { scheduleEvaluate(autoOpen); return Promise.resolve(); }
    processing = true;

    return getCart().then(function (cart) {
      var counts = countBottles(cart);
      var giftItems = giftItemsInCart(cart);
      var ops = [];
      var groups = [];
      var reprompt = false;
      var newUnlock = false; // a higher bottle count made NEW gift options available

      BRANDS.forEach(function (brand) {
        var count = counts[brand] || 0;
        var brandGifts = giftItems.filter(function (it) { return brandOfItem(it) === brand; });

        if (count < 1) {
          brandGifts.forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
          lastEligCount[brand] = 0;
          return;
        }

        var elig = eligibleForBrand(brand, count);
        if (evaluatedOnce && elig.length > (lastEligCount[brand] || 0)) newUnlock = true;
        lastEligCount[brand] = elig.length;
        var eligHandles = new Set(elig.map(function (g) { return g.handle; }));
        var valid = brandGifts.filter(function (it) { var g = giftOfItem(it); return g && eligHandles.has(g.handle); });
        var invalid = brandGifts.filter(function (it) { var g = giftOfItem(it); return !g || !eligHandles.has(g.handle); });

        invalid.forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
        if (invalid.length) reprompt = true;

        var keep = valid[0] || null;
        valid.slice(1).forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
        if (keep && keep.quantity !== 1) { ops.push(function () { return changeQty(keep.key, 1); }); }

        if (elig.length) {
          var cur = keep ? { handle: giftOfItem(keep).handle, variantId: keep.variant_id } : null;
          groups.push({ brand: brand, gifts: elig, current: cur });
        }
      });

      var mutated = ops.length > 0;

      function finish() {
        if (groups.length === 0) {
          hideTrigger();
          closePopup();
        } else {
          renderGroups(groups);
          var needChoice = groups.some(function (g) { return !g.current; });
          showTrigger(!needChoice);
          // open when a choice is needed after an add/tier-change, OR when a
          // higher bottle count just unlocked new gift options (e.g. Golf T-shirt).
          if ((needChoice && (autoOpen || reprompt)) || newUnlock) openPopup();
        }
      }

      return runOps(ops)
        .then(function () { return mutated ? refreshCartUI() : null; })
        .then(finish);
    }).catch(function (e) {
      console.error('[gift-popup]', e);
    }).then(function () {
      processing = false;
      evaluatedOnce = true;
    });
  }

  // ---- wire up events -----------------------------------------------------
  if (popup) {
    Array.prototype.forEach.call(popup.querySelectorAll('[data-gift-close]'), function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  }

  if (trigger) trigger.addEventListener('click', openPopup);

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      getCart()
        .then(function (cart) {
          var giftItems = giftItemsInCart(cart);
          var ops = [];
          currentGroups.forEach(function (g) {
            var sel = selection[g.brand];
            if (!sel || !sel.variantId) return;
            var desired = sel.variantId;
            var brandGifts = giftItems.filter(function (it) { return brandOfItem(it) === g.brand; });
            var keptDesired = false;
            brandGifts.forEach(function (it) {
              if (it.variant_id === desired && !keptDesired) {
                keptDesired = true;
                if (it.quantity !== 1) ops.push(function () { return changeQty(it.key, 1); });
              } else {
                ops.push(function () { return changeQty(it.key, 0); });
              }
            });
            if (!keptDesired) ops.push(function () { return addGift(desired); });
          });
          return runOps(ops);
        })
        .then(refreshCartUI)
        .then(function () { closePopup(); return evaluate(false); })
        .catch(function (e) {
          console.error('[gift-popup] add failed', e);
          addBtn.disabled = false;
        });
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'gift-popup') return;
      var auto = !(event && event.source === 'cart-items');
      scheduleEvaluate(auto);
    });
  }

  evaluate(false);
})();
